import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/museum/rectangle_mobile.png'
import _imports_1 from '@/assets/images/museum/rectangle_desktop.png'


const _withScopeId = n => (_pushScopeId("data-v-0da4686e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progress" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "Shadow" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = { class: "Inner" }
const _hoisted_7 = { class: "Header" }
const _hoisted_8 = { class: "Suptitle small-caps" }
const _hoisted_9 = ["innerHTML"]

import { gsap } from 'gsap'

import AppService from '@/store/states/AppService'
import type { ArtworkId } from '@/store/states/Artworks'
import useArtwork from './useArtwork'

import {
  DIRECTION as UIBtnSecondaryDirection,
  THEME as UIBtnSecondaryTheme,
} from '@/components/UIBtn/UIBtnSecondary.vue'
import UIBtnDive from '@/components/UIBtn/UIBtnDive.vue'

import { useSelector } from '@xstate/vue'
import Viewport from '@/store/modules/Viewport'
import Gtm from '@/utils/Gtm'

interface Props {
  artworkId: ArtworkId,
  open: Boolean
}

interface CardSize {
  finaleCardY?: number,
  cardY?: number,
  cardOffsetY?: number,
  titleScale?: number,
  subtitleOffsetY?: number
}


import { computed, defineComponent, onMounted, ref, ComponentPublicInstance, watch, nextTick, onBeforeUnmount } from 'vue'

const __default__ = defineComponent({
})

function setup(__props: any) {

const props = __props as {
  artworkId: ArtworkId,
  open: Boolean
}


const artwork = useArtwork(props.artworkId)

const isMobile = computed(() => !Viewport.isDesktop)
const showDive = computed(() => isMobile.value && artwork.isMainPainting)

const selectedArtworkId = useSelector(AppService, state => state.context.selectedArtworkId)
const showArtworkDetails = computed(() => {
  return !!selectedArtworkId.value
})

watch(showArtworkDetails, (open) => {
  (open)
  if (open) {
    showDetails()
  } else {
    exit()
  }
})

const hasScroll = ref(false)
const scroll = ref<HTMLDivElement>(null)
const scrollInner = ref<HTMLDivElement>(null)
const scrollBar = ref<HTMLDivElement>(null)


const readMoreBtn = ref<ComponentPublicInstance>(null)
const card = ref<HTMLDivElement>(null)

const content = ref<HTMLDivElement>(null)
const title = ref<HTMLDivElement>(null)
const subtitle = ref<HTMLDivElement>(null)
const spanMaterial = ref<HTMLSpanElement>(null)
const spanMainPainting = ref<HTMLSpanElement>(null)
const spanMuseum = ref<HTMLSpanElement>(null)
const cardSize: CardSize = {}

onMounted(() => {
  getLastPosition()
  if (props.open) showDetails()
})

onBeforeUnmount(() => {
  AppService.send({ type: 'SELECT_ARTWORK', artworkId: null })
})

function getLastPosition() {
  const suptitle = card.value.querySelector('.Suptitle')
  gsap.set(suptitle, { height: spanMuseum.value.offsetHeight, })

  const bbox = card.value.getBoundingClientRect()
  const bboxContent = content.value.getBoundingClientRect()
  const bboxTitle = title.value.getBoundingClientRect()

  const smallScale = 0.73
  const smallHeight = bboxTitle.height * smallScale
  const diffTitleHeight = bboxTitle.height - smallHeight

  cardSize.cardY = bbox.top
  cardSize.cardOffsetY = bboxContent.height + diffTitleHeight - 32
  cardSize.titleScale = smallScale
  cardSize.subtitleOffsetY = -diffTitleHeight


  gsap.set(card.value, { y: cardSize.cardOffsetY })
  gsap.set(title.value, { scale: cardSize.titleScale })
  gsap.set(subtitle.value, { y: cardSize.subtitleOffsetY })
}

function handlerExit() {
  AppService.send({ type: 'SELECT_ARTWORK', artworkId: null })
}

function showDetails() {

  Gtm.sendEventPush(
    'artwork',
    'read-more',
    `Click on ${artwork.id} ${artwork.isMainPainting ? 'main painting': ''}`
  )

  const allDivinBtn = document.querySelectorAll('.UIBtnDive')
  const bbox = card.value.getBoundingClientRect()

  const topY = Viewport.isDesktop ? 130 : Viewport.windowHeight * 0.5
  const maxY = -cardSize.cardY + topY
  const yCard = Math.max(-cardSize.cardY + (Viewport.windowHeight * 0.5) - (bbox.height * 0.5), maxY)
  cardSize.finaleCardY = yCard

  const fakeHeight = topY + bbox.height + 100
  setFakeScroll(bbox, fakeHeight)

  const tl = gsap.timeline({
    onComplete: () => {
      scroll.value.addEventListener('click', handlerExit)
    }
  })
  tl

    .set([spanMuseum.value, spanMaterial.value], {
      yPercent: 100,
      y: 0
    })
    .to([readMoreBtn.value.$el, allDivinBtn], {
      autoAlpha: 0
    }, 'start')
    .to(content.value, {
      autoAlpha: 1
    }, 'start')
    .to(card.value, {
      y: cardSize.finaleCardY,
      x: Viewport.isDesktop ? '+=60' : 0,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')
    .to(title.value, {
      scale: 1,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')
    .to(subtitle.value, {
      y: 0,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')

    .to(spanMainPainting.value, {
      yPercent: -100,
      duration: 0.7,
      ease: 'quint.inOut'
    }, 'start+=0.4')
    .to(spanMuseum.value, {
      yPercent: 0,
      duration: 0.7,
      ease: 'quint.inOut'
    }, 'start+=0.4')
    .to(spanMaterial.value, {
      yPercent: 0,
      duration: 0.7,
      ease: 'quint.inOut'
    }, 'start+=0.4')
}

const scrollParams = {
  height: 0,
  scrollBarHeight: 0
}

function setFakeScroll(bbox, fakeHeight) {
  scrollParams.height = fakeHeight
  scrollParams.scrollBarHeight = Viewport.windowHeight / scrollParams.height

  scroll.value.style.setProperty('--height-container', `${scrollParams.height}px`)

  let x = Viewport.isDesktop ? 60 : 0
  x += bbox.left + bbox.width

  gsap.set(scroll.value, { autoAlpha: 0, height: Viewport.windowHeight })

  if (scrollParams.scrollBarHeight <= 0.9) {
    scroll.value.style.setProperty('--offset-x', `${x}px`)
    scroll.value.style.setProperty('--offset-y', `${bbox.top}px`)
    scroll.value.style.setProperty('--height-progress', `${(scrollParams.scrollBarHeight) * 100}%`)

    gsap.to(scroll.value, { autoAlpha: 1, delay: 1.2 })
    hasScroll.value = true
  }
}

function disableScroll() {
  if (!scroll.value) return
  scroll.value.removeEventListener('click', handlerExit)
  hasScroll.value = false
  gsap.set(scroll.value, { autoAlpha: 0 })
}

function onClickBackMuseum() {
  AppService.send({ type: 'SELECT_ARTWORK', artworkId: null })

  Gtm.sendEventPush(
    'artwork',
    'close-artwork-description',
    `Click on Go back to museum`
  )
}

function exit() {
  const allDivinBtn = document.querySelectorAll('.UIBtnDive')

  const tl = gsap.timeline({
  })
  tl
    .to([readMoreBtn.value.$el, allDivinBtn], {
      autoAlpha: 1
    }, 'start+=1.2')
    .to(content.value, {
      autoAlpha: 0,
      duration: 1.067,
      onComplete: () => {
        disableScroll()
      }
    }, 'start')
    .to(card.value, {
      y: cardSize.cardOffsetY,
      x: 0,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')
    .to(title.value, {
      scale: cardSize.titleScale,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')
    .to(subtitle.value, {
      y: cardSize.subtitleOffsetY,
      duration: 1.067,
      ease: 'quint.inOut'
    }, 'start')

    .to(spanMainPainting.value, {
      yPercent: 0,
      duration: 0.6,
      ease: 'quint.inOut'
    }, 'start')
    .to(spanMuseum.value, {
      yPercent: 105,
      duration: 0.6,
      ease: 'quint.inOut'
    }, 'start')
    .to(spanMaterial.value, {
      yPercent: 105,
      duration: 0.6,
      ease: 'quint.inOut'
    }, 'start')

}


function onFakeScroll(e) {
  const el = e.target
  const scrollY = el.scrollTop


  const heightScrollBar = Viewport.windowHeight * 0.5
  const progressPercent = ((scrollY / (el.scrollHeight - el.offsetHeight)))

  const heightToScroll = heightScrollBar - (heightScrollBar * scrollParams.scrollBarHeight)
  const progressScroll = heightToScroll * progressPercent

  scroll.value.style.setProperty('--progress', `${progressScroll}px`)

  const y = cardSize.finaleCardY - scrollY
  gsap.set(card.value, {
    y
  })
}

function onDive() {
  AppService.send('GOTO_PAINTING')
  Gtm.sendEventPush(
    'header',
    'step-to-immersive-painting',
    'Click on Step to immersive painting'
  )
}


return (_ctx: any,_cache: any) => {
  const _component_heading = _resolveComponent("heading")!
  const _component_ui_btn_secondary = _resolveComponent("ui-btn-secondary")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ArtworkCaption", { 'ArtworkCaption--opened': _unref(showArtworkDetails), 'ArtworkCaption--has-scroll': hasScroll.value }])
  }, [
    _withDirectives(_createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['scroll'] = _value
        scroll.value = _value
      },
      class: "FakeScroll",
      onScroll: onFakeScroll
    }, [
      _createElementVNode("div", {
        ref: (_value, _refs) => {
          _refs['scrollBar'] = _value
          scrollBar.value = _value
        },
        class: "FakeScroll__bar"
      }, _hoisted_2, 512),
      _createElementVNode("div", {
        ref: (_value, _refs) => {
          _refs['scrollInner'] = _value
          scrollInner.value = _value
        },
        class: "FakeScroll__inner"
      }, null, 512)
    ], 544), [
      [_vShow, _unref(showArtworkDetails)]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : (_openBlock(), _createElementBlock("img", _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        ref: (_value, _refs) => {
          _refs['card'] = _value
          card.value = _value
        },
        class: "Card"
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['title'] = _value
              title.value = _value
            },
            class: "Title"
          }, [
            _createVNode(_component_heading, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!_unref(showArtworkDetails) && _unref(AppService).send({ type: 'SELECT_ARTWORK', artworkId: props.artworkId }))),
              text: _ctx.$rt(_unref(artwork).title)
            }, null, 8, ["text"])
          ], 512),
          _createElementVNode("div", {
            ref: (_value, _refs) => {
              _refs['subtitle'] = _value
              subtitle.value = _value
            },
            class: "Subtitle small-caps"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$rt(_unref(artwork).date)), 1),
            _createElementVNode("span", {
              ref: (_value, _refs) => {
                _refs['spanMaterial'] = _value
                spanMaterial.value = _value
              },
              class: "material"
            }, "— " + _toDisplayString(_ctx.$rt(_unref(artwork).material)), 513)
          ], 512),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("span", {
              ref: (_value, _refs) => {
                _refs['spanMainPainting'] = _value
                spanMainPainting.value = _value
              },
              class: "main-painting"
            }, _toDisplayString(_ctx.$t('museum.main_painting_label')), 513), [
              [_vShow, _unref(artwork).isMainPainting]
            ]),
            _createElementVNode("span", {
              ref: (_value, _refs) => {
                _refs['spanMuseum'] = _value
                spanMuseum.value = _value
              },
              class: "museum"
            }, _toDisplayString(_ctx.$rt(_unref(artwork).museum)), 513)
          ])
        ]),
        _createElementVNode("div", {
          ref: (_value, _refs) => {
            _refs['content'] = _value
            content.value = _value
          },
          class: "Content"
        }, [
          _createElementVNode("div", {
            class: "Description text",
            innerHTML: _ctx.$rt(_unref(artwork).description)
          }, null, 8, _hoisted_9),
          _createVNode(_component_ui_btn_secondary, {
            direction: _unref(UIBtnSecondaryDirection).BACKWARDS,
            theme: _unref(UIBtnSecondaryTheme).LIGHT,
            onClick: onClickBackMuseum
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.back_to_museum')), 1)
            ]),
            _: 1
          }, 8, ["direction", "theme"])
        ], 512)
      ], 512),
      _withDirectives(_createVNode(_component_ui_btn_secondary, {
        ref: (_value, _refs) => {
          _refs['readMoreBtn'] = _value
          readMoreBtn.value = _value
        },
        theme: _unref(UIBtnSecondaryTheme).LIGHT,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(AppService).send({ type: 'SELECT_ARTWORK', artworkId: props.artworkId })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.read_more')), 1)
        ]),
        _: 1
      }, 8, ["theme"]), [
        [_vShow, !_unref(isMobile)]
      ]),
      _withDirectives(_createVNode(UIBtnDive, {
        type: "button",
        onClick: onDive
      }, null, 512), [
        [_vShow, _unref(showDive)]
      ])
    ])
  ], 2))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artworkId: null,
    open: null
  },
  setup})